'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ReactNode } from 'react';

/**
 * Theme provider component that wraps the application
 * Provides light/dark mode functionality
 * Default theme set to dark mode
 * Uses suppressHydrationWarning to prevent hydration mismatches
 */
export function ThemeProvider({ 
  children, 
  ...props 
}: { 
  children: ReactNode;
  [key: string]: unknown;
}) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
} 